module.exports = __webpack_public_path__ + "static/img/character-1.74b8ab5f.png";